<pagination-template
  #p="paginationApi"
  [id]="id"
  [maxSize]="maxSize"
  (pageChange)="pageChange.emit($event)"
>
  <nav
    class="ecom-pagination"
    *ngIf="!(autoHide && p.pages.length <= 1)"
    aria-label="Page navigation"
  >
    <ul class="ecom-pagination-list">
      <!-- Previous -->
      <li
        *ngIf="directionLinks"
        class="ecom-page-item"
        [class.ecom-page-item-disabled]="p.isFirstPage()"
      >
        <a
          class="ecom-page-link ecom-page-link-prev"
          href="javascript:;"
          [attr.aria-disabled]="p.isFirstPage()"
          [attr.tabindex]="p.isFirstPage() ? -1 : 0"
          (click)="!p.isFirstPage() && p.previous()"
        >
          <i class="fas fa-chevron-left ecom-page-icon"></i>
          <span class="ecom-page-text">{{'Previous'|localize}}</span>
        </a>
      </li>

      <!-- Pages -->
      <li
        *ngFor="let page of p.pages"
        class="ecom-page-item"
      >
        <a
          class="ecom-page-link"
          [class.ecom-page-link-active]="p.getCurrent() === page.value"
          href="javascript:;"
          (click)="p.setCurrent(page.value)"
          [attr.aria-current]="p.getCurrent() === page.value ? 'page' : null"
        >
          {{ page.label }}
        </a>
      </li>

      <!-- Next -->
      <li
        *ngIf="directionLinks"
        class="ecom-page-item"
        [class.ecom-page-item-disabled]="p.isLastPage()"
      >
        <a
          class="ecom-page-link ecom-page-link-next"
          href="javascript:;"
          [attr.aria-disabled]="p.isLastPage()"
          [attr.tabindex]="p.isLastPage() ? -1 : 0"
          (click)="!p.isLastPage() && p.next()"
        >
          <span class="ecom-page-text">{{'Next'|localize}}</span>
          <i class="fas fa-chevron-right ecom-page-icon"></i>
        </a>
      </li>
    </ul>
  </nav>

  <style>
    .ecom-pagination {
      display: flex;
      justify-content: center;
      margin-top: 1.5rem;
      font-size: 0.9rem;
    }

    .ecom-pagination-list {
      display: inline-flex;
      align-items: center;
      gap: 0.4rem;
      padding: 0.4rem 0.8rem;
      border-radius: 999px;
      background-color: #ffffff;
      box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
      list-style: none;
      margin: 0;
      flex-wrap: wrap;
    }

    .ecom-page-item {
      display: inline-flex;
    }

    .ecom-page-link {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 2rem;
      height: 1.8rem;
      padding: 0 0.75rem;
      border-radius: 999px;
      border: none;
      font-weight: 500;
      font-size: 0.85rem;
      color: #64748b;
      background-color: #f9fafb;
      text-decoration: none;
      transition: all 0.18s ease-out;
      box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.18);
      cursor: pointer;
      white-space: nowrap;
    }

    .ecom-page-link:hover {
      background-color: #ffffff;
      color: #0f172a;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.1);
      transform: translateY(-1px);
    }

    .ecom-page-link:focus-visible {
      outline: 2px solid #f97316;
      outline-offset: 2px;
    }

    .ecom-page-link-active {
      background: linear-gradient(135deg, #ff6a1a, #ff4d00);
      color: #ffffff;
      box-shadow: 0 6px 16px rgba(248, 113, 22, 0.45);
      cursor: default;
    }

    .ecom-page-link-active:hover {
      transform: none;
      box-shadow: 0 6px 16px rgba(248, 113, 22, 0.45);
    }

    .ecom-page-item-disabled .ecom-page-link {
      background-color: #f3f4f6;
      color: #cbd5e1;
      box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.18);
      cursor: not-allowed;
      transform: none;
    }

    .ecom-page-item-disabled .ecom-page-link:hover {
      background-color: #f3f4f6;
      color: #cbd5e1;
      box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.18);
    }

    .ecom-page-link-prev,
    .ecom-page-link-next {
      padding-inline: 0.9rem;
      gap: 0.3rem;
    }

    .ecom-page-icon {
      font-size: 0.7rem;
    }

    .ecom-page-text {
      letter-spacing: 0.01em;
    }

    @media (max-width: 576px) {
      .ecom-pagination {
        margin-top: 1rem;
      }

      .ecom-pagination-list {
        padding: 0.3rem 0.5rem;
        gap: 0.25rem;
      }

      .ecom-page-link {
        min-width: 2.1rem;
        height: 2.1rem;
        padding-inline: 0.6rem;
        font-size: 0.8rem;
      }

      .ecom-page-link-prev .ecom-page-text,
      .ecom-page-link-next .ecom-page-text {
        display: none;
      }
    }
  </style>
</pagination-template>
